module.exports = __webpack_public_path__ + "img/user_logo.0dce4426.png";